import enUS from "./en-US.json";
import id from "./id.json";

const lang = { enUS, id };

export default lang;
